module.exports = __webpack_public_path__ + "static/media/imgpsh_fullsize_anim.037d1e68.png";